<header>
  <div class="d-flex dialog-header">
    <h3 class="dialog-title" translate>
      <fa-icon [icon]="['fas', modeIcon]" class="pr-2" ></fa-icon>{{ modeLabel | translate }}
    </h3>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <button (click)="onSubmit()" class="btn ml-1 btn-primary" [disabled]="inProgress">
            <fa-icon [icon]="['fas', (submitted) ? 'spinner' : 'save']" [spin]="submitted"></fa-icon><span class="pl-1">{{ 'save' | translate }}</span>
          </button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="cancelDialog()"
            icon="times"
            label="close"
            variant="error"
            [disabled]="inProgress"
          >
          </fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>
<hr />
<mat-dialog-content class="mobile-view-dialog">
  <ng-container *ngIf="!loading" >
    <form [formGroup]="emailTemplateForm">
      <div class="mb-3">
        <app-edit-field [item]="emailTemplateField['name']" [form]="emailTemplateForm"></app-edit-field>
      </div>

      <div class="mb-3">
        <app-edit-field [item]="emailTemplateField['share_template']" [form]="emailTemplateForm"></app-edit-field>
      </div>
      <div class="form-group">
        <label for="attachment" class="fs-14">{{ 'attachment' | translate }}</label>
        <div>
          <div class="attachment-container">
            <div *ngFor="let item of attachmentList" class="attachment-list">
              <fa-icon [icon]="['fas', 'times-circle']" class="attachment-item" (click)="removeAttachement(item.name)" *ngIf="item.upload_name"></fa-icon>
              <inline-view-loader [isLoading]="! item.upload_name" [hasText]="false"></inline-view-loader>
              {{ item.name }} - {{ item.size | number:'.2' }} kb
            </div>
          </div>
          <div ng2FileDrop
            id="attachment"
            [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
            (fileOver)="fileOverBase($event)"
            [uploader]="fileUploader"
            (onFileDrop)="dropAttachment($event)"
            class="well my-drop-zone"
            #attachment>
            {{ 'drop_files_here' | translate }}
          </div>
        </div>
      <div *ngIf="objAvailableModules" class="mb-3 mt-3 row">
          <div class="col-md-12">
            <app-edit-field
              [item]="emailTemplateField['module']"
              [form]="emailTemplateForm"
              [strModule]="'email-templates'"
              (parentEvent)="onChangeModule($event)">
            </app-edit-field>
          </div>
      </div>
      <div class="mb-3">
        <app-edit-field
        [item]="emailTemplateField['subject']"
        [form]="emailTemplateForm"
        (focus)="onInputFocus($event)"></app-edit-field>
      </div>

      </div>
      <quill-editor
        #quill
        formControlName="body"
        placeholder="Enter Text"
        [modules]="quillConfig"
        (onFocus)="onQuillFocus($event)"
        [style]="{'height':'220px'}">
        <div quill-editor-toolbar>
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-code-block"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-indent" value="-1"></button>
            <button class="ql-indent" value="+1"></button>
          </span>
          <span class="ql-formats">
            <select class="ql-size">
              <option value="small"></option>
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
          </span>
          <span class="ql-formats">
            <select class="ql-header">
              <option value="1"></option>
              <option value="2"></option>
              <option value="3"></option>
              <option value="4"></option>
              <option value="5"></option>
              <option value="6"></option>
              <option selected></option>
            </select>
          </span>
          <span class="ql-formats">
            <select class="ql-font"></select>
          </span>
          <span class="ql-formats">
            <select class="ql-align"></select>
          </span>
          <span class="ql-formats">
            <button class="ql-link"></button>
          </span>
          <span class="ql-formats" [matTooltip]="'add_dynamic_variables' | translate">
            <button (click)="addDynamicVariables()" style="height: 50px;">&#123;&#125;</button>
          </span>
          <span class="ql-formats">
            <div class="dynamic-variables-container"
                [class.show]="showDynamicVariables"
                style="width: 220px;"
                id="related-field-container">
              <fieldmagic-dropdown-input
                #dropdownInput
                [standalone]="true"
                [options]="fields$ | async"
                [placeholder]="'variable_select_field_to_add' | translate"
                [grouped]="true"
                [isOpen]="isOpen"
                (blur)="showDynamicVariables = false; isOpen = false;"
                (change)="onRelatedFieldChange($event)"
              ></fieldmagic-dropdown-input>
            </div>
          </span>
        </div>
      </quill-editor>
    </form>
  </ng-container>
</mat-dialog-content>